import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { ToastService } from 'src/app/shared/services/toast/toast.service';
import { AuthService } from '../shared/auth.service';

@Component({
  selector: 'app-recover-password',
  templateUrl: './recover-password.component.html',
  styleUrls: ['./recover-password.component.sass'],
})
export class RecoverPasswordComponent {
  email = '';
  loading = false;
  submitted = false;

  constructor(
    private authService: AuthService,
    private toastService: ToastService,
    private router: Router
  ) {}

  onSubmit() {
    if (!this.email) {
      this.toastService.showWarn('Por favor, informe seu e-mail.');
      return;
    }

    this.loading = true;
    this.authService.recoverPassword(this.email).subscribe({
      next: (response) => {
        this.loading = false;
        this.submitted = true;
      },
      error: () => {
        this.loading = false;
        // Mensagem neutra mesmo em erro para não revelar se o e-mail existe
        this.submitted = true;
      },
    });
  }
}
